// eslint-disable-next-line 
// @ts-ignore Prevents build failing with: Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
globalThis.import_meta_env = JSON.parse('"import_meta_env_placeholder"');
// The line above is a (special-expression) placeholder, as per the docs:
// https://import-meta-env.org/guide/getting-started/introduction.html#special-expression

const parseNumberEnvVar = (value: string): number | undefined => {
  const number = Number(value);
  return isNaN(number) ? undefined : number;
};

export const CORE_API_BASE_URL = import.meta.env.CORE_API_BASE_URL;
export const SCA_API_BASE_URL = import.meta.env.SCA_API_BASE_URL;
export const GLOBAL_API_BASE_URL = import.meta.env.GLOBAL_API_BASE_URL;
export const VERIFY_API_BASE_URL = import.meta.env.VERIFY_API_BASE_URL;
export const CHECKOUT_API_BASE_URL = import.meta.env.CHECKOUT_API_BASE_URL;
export const VERSION = import.meta.env.VERSION;
export const APP_ENV = import.meta.env.APP_ENV;
export const SENTRY_DSN = import.meta.env.SENTRY_DSN;
export const MIXPANEL_TOKEN = import.meta.env.MIXPANEL_TOKEN;
export const CALLSIGN_ORGANIZATION_ID = import.meta.env.CALLSIGN_ORGANIZATION_ID;
export const CHECKOUT_NEW_RELIC_LICENSE_KEY = import.meta.env.CHECKOUT_NEW_RELIC_LICENSE_KEY;
export const CHECKOUT_NEW_RELIC_ACCOUNT_ID = import.meta.env.CHECKOUT_NEW_RELIC_ACCOUNT_ID;
export const CHECKOUT_NEW_RELIC_TRUST_KEY = import.meta.env.CHECKOUT_NEW_RELIC_TRUST_KEY;
export const CHECKOUT_NEW_RELIC_APPLICATION_ID = import.meta.env.CHECKOUT_NEW_RELIC_APPLICATION_ID;
export const SSE_ENDPOINT_URL = import.meta.env.SSE_ENDPOINT_URL || 'http://localhost:9999';
export const ALCHEMY_PROJECT_ID = import.meta.env.ALCHEMY_PROJECT_ID;
export const REOWN_PROJECT_ID = import.meta.env.REOWN_PROJECT_ID;
export const ZELDA_API_BASE_URL = import.meta.env.ZELDA_API_BASE_URL;

export const SENTRY_TRACES_SAMPLE_RATE = parseNumberEnvVar(
  import.meta.env.SENTRY_TRACES_SAMPLE_RATE
);
